import { matomoPush } from './trackEvent'

export function initMatomo(): void {
  const jsURL = import.meta.env.VUE_APP_MATOMO_URL || ''
  if (!jsURL) return

  // Ensure _paq exists as array until matomo script loads
  globalThis._paq = globalThis._paq || []

  const d = document
  const g = d.createElement('script')
  const s = d.getElementsByTagName('script')[0]

  g.type = 'text/javascript'
  g.async = true
  g.defer = true
  g.src = jsURL

  s?.parentNode?.insertBefore(g, s)

  // disable session recording
  matomoPush(['HeatmapSessionRecording.addConfig', {}])
}
